import { render, staticRenderFns } from "./NaturalTextMenu.vue?vue&type=template&id=4bdbfcaf&"
import script from "./NaturalTextMenu.vue?vue&type=script&lang=ts&"
export * from "./NaturalTextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports